module.exports = __webpack_public_path__ + "assets/img/tcc.d6183e6c.png";